import React from "react";

// Arrow icon SVG component
const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#FC7600">
    <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
  </svg>
);

const Technologysection = ({ mainTitle, subTitle, categories }) => {
  return (
    <section className="technology-stack-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="tech-stack-content">
              <h2 className="tech-stack-title text-center">{mainTitle}</h2>
              <p className="tech-stack-description">{subTitle}</p>
              <div className="tech-stack-grid">
                {categories &&
                  categories.length > 0 &&
                  categories.map((category, categoryIndex) => (
                    <div className="tech-card" key={categoryIndex}>
                      <h3 className="tech-card-title">{category.title}</h3>

                      <div className="hedding process-underline-flex">
                        <div className="process-underline"></div>
                        <div className="process-underline"></div>
                      </div>

                      <ul className="tech-list">
                        {category.items &&
                          category.items.length > 0 &&
                          category.items.map((item, itemIndex) => (
                            <li
                              className="tecno-hedding new-tecno"
                              key={itemIndex}
                            >
                              <div>
                                <ArrowIcon />
                              </div>
                              <div>
                                <span className="text-bold">{item.label}</span>{" "}
                                – {item.text}
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologysection;
